import React from 'react';
import {
	Modal,
	Stack,
	Box
} from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

// custom components
import PrimaryButton from '../buttons/primary-button';
import SecondaryButton from '../buttons/secondary-button';
import Body2 from '../typography/body-02';

// custom styles
import styles from './confirmation-modal/index.module.scss';

const DocumentInfoModal = ({
	open,
	text,
	confirmText,
	handleConfirm,
	closeText,
	handleClose,
}) => {
	return (
		<Modal
			open={open}
			aria-labelledby="document info modal"
			aria-describedby="document info modal"
			disableAutoFocus={true}
			disableEscapeKeyDown={true}
		>
			<Stack
				direction="column"
				justifyContent="center"
				alignItems="center"
				className={styles.modalBodyContainer}
			>
				<InfoOutlined 
					className={styles.iconContainer} 
					style={{ color: '#095271' }}
				/>

				<Stack
					direction="column"
					alignItems="center"
					className={styles.textContainer}
				>
					<Body2 text={text} extraClass={styles.confirmationText} />
				</Stack>

				<PrimaryButton
					text={confirmText}
					onClick={handleConfirm}
					fullWidth={true}
				/>

				<SecondaryButton
					text={closeText}
					onClick={handleClose}
					fullWidth={true}
					extraClass={styles.closeBtn}
					extraTextClass={styles.closeBtnText}
				/>
			</Stack>
		</Modal>
	);
};

export default DocumentInfoModal;
